import {mapState, mapMutations} from 'vuex'

export const journalSidebar = {

  computed: {
    ...mapState({
      showJournalSidebar: state => state.openProjectsNavigator
    }),

  },
  methods: {
    ...mapMutations({
      setShowJournalSidebar: 'TOGGLE_OPEN_PROJECTS_NAVIGATOR'
    }),
  }
};
